import ItemContent from 'modules/stores/store/components/item-content'
import ItemWrapper from 'modules/stores/store/components/item-wrapper'
import { useOptinActions } from 'modules/stores/store/content/optin/hooks/use-optin-actions'
import { OptinItemViewType } from 'modules/stores/store/content/optin/types/optin-interface'
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item'
import { useChangeItemDraft } from '../../hooks/use-change-item-draft'
import { getOptinUpdateData } from './utils/get-optin-update-data'

const OptinContent = (optinView: OptinItemViewType) => {
  const { deleteOptin, updateOptin } = useOptinActions()

  const { onDelete } = useDeleteItem()

  const onDeleteOptin = () =>
    onDelete({ deleteCallback: () => deleteOptin(optinView.id), itemId: optinView.itemId })

  const { onChangeItemDraft } = useChangeItemDraft()

  const onSaveDraft = () => {
    return onChangeItemDraft({
      callback: async () => {
        await updateOptin(optinView.id, getOptinUpdateData({ ...optinView, draft: true }))
      },
      itemId: optinView.itemId,
      draft: true,
    })
  }

  const onPublish = () => {
    return onChangeItemDraft({
      callback: async () => {
        await updateOptin(optinView.id, getOptinUpdateData({ ...optinView, draft: false }))
      },
      itemId: optinView.itemId,
      draft: false,
    })
  }

  return (
    <ItemWrapper id={optinView.itemId}>
      <ItemContent
        draft={optinView.draft}
        onDelete={onDeleteOptin}
        onSaveDraft={onSaveDraft}
        onPublish={onPublish}
        itemId={optinView.itemId}
        title={optinView.title}
        itemType={optinView.type}
        thumbnail={optinView.thumbnail}
      />
    </ItemWrapper>
  )
}

export default OptinContent
